import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'ru', label: 'RU' },
] as const;

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentLang = LANGUAGES.find((l) => i18n.language?.startsWith(l.code)) ?? LANGUAGES[0];

  function handleToggle() {
    const next = currentLang.code === 'en' ? 'ru' : 'en';
    i18n.changeLanguage(next);
  }

  return (
    <button
      onClick={handleToggle}
      className="px-2 py-1 text-xs font-medium rounded border border-dark-border text-warm-400 hover:text-warm-100 hover:border-warm-600 transition-colors"
      aria-label={`Switch language to ${currentLang.code === 'en' ? 'Russian' : 'English'}`}
    >
      {currentLang.label}
    </button>
  );
}
